import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Fetches a URL like /api/files/... as a blob and returns a blob URL usable in <img src>.
 *  Automatically strips leading /api since axios baseURL already ends in /api.
 */
export function useAuthedImage(url) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (!url) { setSrc(""); return; }
    let cancelled = false;
    let blobUrl = null;
    (async () => {
      try {
        const rel = url.replace(/^\/api/, "");
        const r = await api.get(rel, { responseType: "blob" });
        if (cancelled) return;
        blobUrl = URL.createObjectURL(r.data);
        setSrc(blobUrl);
      } catch (e) {
        console.error("AuthedImage load failed", url, e);
      }
    })();
    return () => { cancelled = true; if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [url]);
  return src;
}

export function AuthedImage({ url, alt = "", className = "", fallback = null }) {
  const src = useAuthedImage(url);
  if (!url) return fallback;
  if (!src) return <div className={`${className} bg-secondary/40 animate-pulse`} />;
  return <img src={src} alt={alt} className={className} />;
}
